import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end w-100"
}
const _hoisted_2 = {
  class: "align-middle",
  style: {"color":"crimson","margin":"0"}
}
const _hoisted_3 = { class: "d-flex justify-content-end" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-end",
  style: {"color":"crimson"}
}


import i18n from '@/lang/i18n';

const showMaxLength = 3 as number

export default /*@__PURE__*/_defineComponent({
  __name: 'ITTenkoStatusMessage',
  props: {
    messages: {},
    showModalButton: { type: Boolean }
  },
  emits: ['openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const btnName = i18n.global.t('pages.dailyReports.errorAllDisplay') as string

function openModal() {
  emits('openModal')
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.messages, (message, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "d-flex justify-content-end"
      }, [
        (index < showMaxLength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, _toDisplayString(message), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        (props.messages.length > showMaxLength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, " more_horiz ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (props.showModalButton)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              class: "mt-2",
              color: "#FF5722",
              style: {"color":"white"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(btnName)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})